import { BigNumber } from "ethers";
import { parseUnits } from "ethers/lib/utils";
import { getDisplayAssets, VaultAddressMap, } from "../constants/constants";
import { getAssetColor } from "./asset";
export var isVaultFull = function (deposits, cap, decimals) {
    var margin = parseUnits("0.01", decimals);
    return !cap.isZero() && deposits.gte(cap.sub(margin));
};
export var isVaultSupportedOnChain = function (vaultOption, chainId) {
    return VaultAddressMap[vaultOption].chainId === chainId;
};
export var isETHVault = function (vault) {
    return ["bETH-THETA", "rstETH-THETA"].includes(vault);
};
export var getVaultColor = function (vault) {
    return getAssetColor(getDisplayAssets(vault));
};
/*** SOLANA-ONLY UTILS ***/
export var isEqualsToUserAddress = function (userKey, nodeKey) {
    return userKey === null || userKey === void 0 ? void 0 : userKey.equals(nodeKey);
};
export var getUserDepositQueueAmount = function (vault, userKey) {
    var depositNodes = vault.depositQueue.filter(function (node) {
        return node.info.userKey.equals(userKey);
    });
    return depositNodes.reduce(function (acc, node) { return acc.add(BigNumber.from(node.info.amount.toNumber())); }, BigNumber.from(0));
};
export var getUserWithdrawQueueAmount = function (vault, userKey) {
    var withdrawalNodes = vault.withdrawalQueue.filter(function (node) {
        return node.info.userKey.equals(userKey);
    });
    return withdrawalNodes.reduce(function (acc, node) { return acc.add(BigNumber.from(node.info.amount.toNumber())); }, BigNumber.from(0));
};
//# sourceMappingURL=vault.js.map